import { get } from '../../../utils/get';
import { getKeys } from '../../../adapters/utils';
import { updateValueByIdentifier } from '../../../tags/values/update-by-identifier';
import { IDENTIFIERS } from '../../../types/Identifiers';
var IDs = {
    NAME: 'blog-category.name',
    IMAGE: 'blog-category.image',
    IMAGE_HEIGHT: 'blog-category.image.height',
    IMAGE_WIDTH: 'blog-category.image.width',
    PAGE_URL: 'blog-category.url',
    PREV_PAGE_URL: 'blog-category.prevUrl',
    NEXT_PAGE_URL: 'blog-category.nextUrl',
};
var userVisible = [IDs.NAME, IDs.PAGE_URL, IDs.IMAGE];
export default {
    IDs: IDs,
    getData: function (item) {
        var _a;
        return (_a = {},
            _a[IDs.NAME] = get(item, 'category.label'),
            _a[IDs.IMAGE] = get(item, 'category.image.url'),
            _a[IDs.IMAGE_HEIGHT] = get(item, 'category.image.height'),
            _a[IDs.IMAGE_WIDTH] = get(item, 'category.image.width'),
            _a[IDs.PAGE_URL] = get(item, 'category.canonicalUrl'),
            _a[IDs.PREV_PAGE_URL] = get(item, 'category.prevUrl'),
            _a[IDs.NEXT_PAGE_URL] = get(item, 'category.nextUrl'),
            _a);
    },
    getLegacySeoBlob: function (item) {
        var tags = updateValueByIdentifier([], IDENTIFIERS.TITLE, get(item, 'category.title'));
        tags = updateValueByIdentifier(tags, IDENTIFIERS.DESCRIPTION, get(item, 'category.description'));
        return { tags: tags };
    },
    getSlug: function () { return ''; },
    updateItemDataWithSlug: function (item) { return item; },
    getBiData: function () { },
    getKeys: function () { return getKeys(IDs, userVisible); },
};
